import { isBanobagiLayout } from "@/utils/layout";

// Campaign deadlines use Thailand time, independently of the device timezone.
// ปุ่มส่งใบเสร็จส่งได้ถึง 12 ต.ค. 2569 12:00:00 น. แล้วปิด
export const BANOBAGI_RECEIPT_CUTOFF = Date.parse("2026-10-12T12:00:00+07:00");
// ลูกค้าเข้าเว็บได้ตั้งแต่ 9 พ.ย. 2569 12:00 น. ถึง 30 พ.ย. 2569 23:59 น.
// นอกช่วงนี้เห็นหน้าปิดระบบ ระหว่างทดสอบเข้าผ่าน ?dev=true ได้
export const BANOBAGI_SITE_OPEN_AT = Date.parse("2026-11-09T12:00:00+07:00");
export const BANOBAGI_SITE_CUTOFF = Date.parse("2026-11-30T23:59:59+07:00");
// Marketplace เชื่อมได้ตามปกติจนกว่าจะปิดระบบ จึงใช้เวลาเดียวกับ site cutoff
// ส่วนเกณฑ์ว่าบิลไหนยังนับสิทธิ์ได้ คุมแยกที่ BANOBAGI_RIGHT_RULES.rightEndDate
export const BANOBAGI_CONNECTION_CUTOFF = BANOBAGI_SITE_CUTOFF;
// วันชั่วคราวของตัวนับถอยหลังหน้าแรก ไม่มีผลกับการคิดสิทธิ์ ต้องเปลี่ยนเมื่อได้วันจริง
export const BANOBAGI_RIGHTS_CLOSE_AT = Date.parse("2026-12-03T23:59:59+07:00");

const MINUTE_MS = 60 * 1000;
const MINUTES_PER_HOUR = 60;
const MINUTES_PER_DAY = 24 * MINUTES_PER_HOUR;

let enabled = false;

const DEV_BYPASS_STORAGE_KEY = "banobagi_dev_bypass";

// เปิดผ่าน liff.line.me พารามิเตอร์จะถูกห่อมาใน liff.state แทน
export function hasBanobagiDevQuery(search) {
  const params = new URLSearchParams(search);
  const liffStateQuery = (params.get("liff.state") || "").split("?")[1] || "";

  return (
    params.get("dev") === "true" ||
    new URLSearchParams(liffStateQuery).get("dev") === "true"
  );
}

// จำไว้ทั้ง session เพราะ redirect ของ LIFF login ทำให้ query หลุด
// เป็นแค่ทางลัดไว้ทดสอบ ไม่ใช่การยืนยันตัวตน คนที่รู้ลิงก์เข้าได้ทุกคน
function isBanobagiDevBypassActive() {
  if (hasBanobagiDevQuery(window.location.search)) {
    window.sessionStorage.setItem(DEV_BYPASS_STORAGE_KEY, "1");
    return true;
  }

  return window.sessionStorage.getItem(DEV_BYPASS_STORAGE_KEY) === "1";
}

export function configureBanobagiAvailability(layout) {
  enabled = isBanobagiLayout(layout) && !isBanobagiDevBypassActive();
}

export function isBanobagiReceiptClosed(now = Date.now()) {
  return enabled && now >= BANOBAGI_RECEIPT_CUTOFF;
}

export function isBanobagiConnectionClosed(now = Date.now()) {
  return enabled && now >= BANOBAGI_CONNECTION_CUTOFF;
}

export function isBanobagiSiteClosed(now = Date.now()) {
  return (
    enabled && (now < BANOBAGI_SITE_OPEN_AT || now >= BANOBAGI_SITE_CUTOFF)
  );
}

export function isBanobagiAvailabilityEnabled() {
  return enabled;
}

export function resolveBanobagiRightsCountdown(
  now = Date.now(),
  closeAt = BANOBAGI_RIGHTS_CLOSE_AT
) {
  const totalMinutes = Math.max(0, Math.floor((closeAt - now) / MINUTE_MS));

  return {
    days: Math.floor(totalMinutes / MINUTES_PER_DAY),
    hours: Math.floor((totalMinutes % MINUTES_PER_DAY) / MINUTES_PER_HOUR),
    minutes: totalMinutes % MINUTES_PER_HOUR
  };
}
